import { Link } from "@tanstack/react-router";

import { focusRing, icons } from "@/ui";
import { isExternalLink } from "@/utils/validation";

type FooterProps = {
  logoRedirectUrl?: string;
};

export const Footer = ({ logoRedirectUrl = "/" }: FooterProps) => {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="border-t border-line bg-ink px-5 py-12 text-ink-content sm:px-10 sm:py-14">
      <div className="mx-auto flex max-w-4xl flex-col gap-5">
        {isExternalLink(logoRedirectUrl) ? (
          <a
            className={`w-fit rounded-md transition-opacity hover:opacity-80 ${focusRing}`}
            href={logoRedirectUrl}
            rel="noreferrer"
            target="_blank"
          >
            <span className="sr-only">EO Care</span>
            <icons.EOCareIcon aria-hidden="true" className="w-10 sm:w-14" />
          </a>
        ) : (
          <Link
            className={`w-fit rounded-md transition-opacity hover:opacity-80 ${focusRing}`}
            to={logoRedirectUrl}
          >
            <span className="sr-only">EO Care home</span>
            <icons.EOCareIcon aria-hidden="true" className="w-10 sm:w-14" />
          </Link>
        )}

        <p className="text-base text-ink-muted sm:text-lg">{`© ${currentYear} All rights reserved. Patents pending. EO Care, Inc.`}</p>
      </div>
    </footer>
  );
};
